module.exports = __webpack_public_path__ + "img/solution21.2ce2cb2c.png";